<div class="user-button-container">
  <div
    class="user-button"
    tabindex="0"
    role="button"
    aria-haspopup="true"
    data-testid="btn-user-menu"
    [attr.aria-expanded]="isMenuOpen"
    (click)="toggleMenu()"
    (keydown.enter)="toggleMenu()"
    (keydown.space)="toggleMenu()">
    <div class="user-info">
      <div class="user-name">
        <div class="first-name">{{ firstName }}</div>
        <div class="last-name">{{ lastName }}</div>
      </div>
    </div>
    <lwty-button
      theme="minimal"
      [trailingIcon]="'chevron-down'"
      [class.rotate]="isMenuOpen" />
  </div>

  @if (isMenuOpen) {
    <div class="user-menu" role="menu">
      <div
        class="menu-item"
        tabindex="0"
        role="menuitem"
        data-testid="menu-my-profile"
        (click)="goToSettings()"
        (keydown.enter)="goToSettings()"
        (keydown.space)="goToSettings()"
        (blur)="closeMenu()">
        <icon-display [iconName]="'cog'" />
        <span>{{ "App.Settings" | translate }}</span>
      </div>
      <div class="menu-divider"></div>
      <div
        class="menu-item"
        tabindex="0"
        role="menuitem"
        (click)="logout()"
        (keydown.enter)="logout()"
        (keydown.space)="logout()"
        (blur)="closeMenu()">
        <icon-display [iconName]="'logout'" />
        <span>{{ "App.Logout" | translate }}</span>
      </div>
    </div>
  }
</div>
